import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { MOCKUP_IMAGE, stats } from '../data/salesContent';
export function Hero() {
  return <header className="w-full bg-ink-900" data-id="element-102" data-mp="9ktfls818azv">
      <div className="mx-auto max-w-4xl px-5 pb-16 pt-10 text-center sm:pt-14" style={{
      paddingTop: "31px"
    }} data-id="element-103" data-mp="9ll8uwe5pwmz">
        <p className="font-sans text-sm font-bold tracking-[0.28em] text-lilac-400" data-id="element-104" data-mp="4na06ozlls6c">
          🌿 REDONDOLAND™
        </p>

        <h1 className="mx-auto mt-8 max-w-3xl font-display text-[2rem] font-bold leading-[1.12] text-white sm:text-5xl" data-id="element-105" data-mp="1274odq5sli7r">
          What If You Could Sneeze, Jump, and Laugh{' '}
          <span className="text-lilac-400" data-id="element-106" data-mp="s9ggdyj6ee7n">Without Thinking Twice</span> — Starting This
          Week?
        </h1>

        <img src={MOCKUP_IMAGE} alt="The Core-Floor Blueprint — 6 volumes and 4 bonus guides shown as a fanned collection" className="mx-auto mt-8 w-full max-w-[19rem] sm:max-w-sm" width={1080} height={1080} style={{
        width: "220px",
        height: "214px"
      }} data-id="element-107" data-mp="neazje4mrpqf" />

        <p className="mx-auto mt-2 max-w-2xl font-display text-lg italic leading-relaxed text-lilac-200 sm:text-xl" data-id="element-108" data-mp="3j9kc5f0exnhp">
          “Everything you've been told about pelvic floor recovery is incomplete. This is
          what actually works.”
        </p>

        <div className="mt-8 flex justify-center" data-id="element-109" data-mp="39cpfz2rm3z6l">
          <CtaButton data-id="element-110" data-mp="3e84orgarj4w5" />
        </div>
        <TrustStrip className="mt-5" data-id="element-111" data-mp="3ebioshvyf20f" />

        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-112" data-mp="30hhsrvwdzt3r">
          {stats.map(s => <div key={s.label} className="rounded-xl border border-white/10 bg-ink-700 px-3 py-4" data-id="element-113" data-mp="358zp26ngt5ie">
              <dt className="sr-only" data-id="element-114" data-mp="2qkmt39odnmnw">{s.label}</dt>
              <dd data-id="element-115" data-mp="2qhqwpps6h61k">
                <span className="block font-display text-2xl font-bold text-lilac-300" data-id="element-116" data-mp="2viy4houbm588">
                  {s.value}
                </span>
                <span className="mt-1 block text-[10px] font-medium uppercase tracking-wider text-muted" data-id="element-117" data-mp="2hk886bfbs9kx">
                  {s.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}